module KendoWidgets
{
	export class ImageOptions
	{
		value?: string;
		width?: string | number;
		height?: string | number;
		tooltip?: string;
		position?: ImagePositionTypeEnum;
		base64?: boolean;
		css?: string;
		preview?: boolean;
		toolbarItems?: ImageToolbarItem[];
		overlayDescription?: boolean | string;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		windowTitle?: string;
		windowWidth?: number;
		windowHeight?: number;

		onHover?(): void;
		onLeave?(): void;
		click?(e: ImageClickEvent): void;
	}

	export class Image extends kendo.ui.Widget implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Image; }

		constructor(element: Element, options?: KendoWidgets.ImageOptions)
		{
			if (options == null)
				options = new KendoWidgets.ImageOptions();

			if (options.position == null) options.position = ImagePositionTypeEnum.Original;
			if (options.base64 == null) options.base64 = false;
			if (options.windowTitle == null) options.windowTitle = "Anteprima immagine";
			if (options.windowWidth == null) options.windowWidth = 800;
			if (options.windowHeight == null) options.windowHeight = 500;
			if (options.preview == null) options.preview = false;
			if (options.overlayDescription == null) options.overlayDescription = false;

			//#region Preview
			if (options.preview == true)
				(element as HTMLElement).style.cssText += "cursor: pointer;";
			//#endregion

			//#region Tooltip
			if (options.tooltip != null)
				(element as HTMLImageElement).alt = options.tooltip;
			//#endregion

			(element as HTMLElement).classList.add("k-image");
			super(element, options);
			let that = this;

			let divContainer = document.createElement("div");
			$(element).wrap(divContainer);
			$(element).css("display", "block");

			//#region Width & Height
			if (typeof (options.width) == "number")
				options.width = options.width + "px";
			(element.parentElement as HTMLElement).style.cssText += "width: " + options.width;
			(element as HTMLElement).style.cssText += "max-width: " + options.width;

			if (typeof (options.height) == "number")
				options.height = options.height + "px";
			(element.parentElement as HTMLElement).style.cssText += "height: " + options.height;
			//#endregion

			(element.parentElement! as HTMLElement).style.cssText += "width: " + options.width + "; display: inline-block; position: relative; height: 100%;";
			$(element).parent().attr("id", element.id + "Parent");
			$(element).parent().addClass("controlParent");

			//#region Image position
			switch (options.position)
			{
				case ImagePositionTypeEnum.Center:
					(element as HTMLElement).style.cssText += "margin: 0 auto; max-width: 100%; max-height: 100%;";
					break;
				case ImagePositionTypeEnum.Fill:
					(element as HTMLElement).style.cssText += "width: 100%; max-height: 100%;";
					break;
				case ImagePositionTypeEnum.Fit:
					(element as HTMLElement).style.cssText += "height: 100%; max-width: 100%;";
					break;
				case ImagePositionTypeEnum.Stretch:
					(element as HTMLElement).style.cssText += "width: 100%; height: 100%;";
					break;
			}
			//#endregion

			//#region Label
			if (options.label != null)
			{
				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 19,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: block;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "display: block;";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 6) + "px)";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";

							(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 6) + "px)";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: block;";
							element.parentElement!.append(label);
							label.style.cssText += "display: block;";
						}
						break;
				}
				//#endregion				
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion			

			//#region Hover
			let parentElement = (options.label != null) ? element.parentElement!.parentElement! : element.parentElement!;
			$(parentElement).hover((e) =>
			{
				if (this.value() != null && this.value() != "")
				{
					if (options!.toolbarItems != null)
						$("#toolbarImage_" + element.id).show();

					if (options!.overlayDescription !== false)
						$("#overlayDescription_" + element.id).show();
				}

				if (options!.onHover != null)
					options!.onHover();
			});
			$(parentElement).mouseleave((e) =>
			{
				if (options!.toolbarItems != null)
					$("#toolbarImage_" + element.id).hide();

				if (options!.overlayDescription !== false)
					$("#overlayDescription_" + element.id).hide();

				if (options!.onLeave != null)
					options!.onLeave();
			});
			//#endregion

			this.value(options.value, (options.base64) ? ImageSourceTypeEnum.Base64Bytes : undefined);

			//#region Toolbar buttons
			if (options.toolbarItems != null)
			{
				$("#toolbarImage_" + element.id).remove();
				let toolbar = document.createElement("div");
				toolbar.id = "toolbarImage_" + element.id;
				toolbar.style.cssText += "z-index: 1; width: 100%; background-color: #000; opacity: 0.5; height: 30px; position: absolute; display: none;";
				$(element.parentElement!).prepend(toolbar);

				for (let toolbarItem of options.toolbarItems)
				{
					switch (toolbarItem.type)
					{
						case ImageToolbarTypeEnum.Download:
							{
								$("#downloadToolbarImage_" + element.id).remove();
								let downloadButton = document.createElement("a");
								downloadButton.id = "downloadToolbarImage_" + element.id;
								downloadButton.download = "download";
								downloadButton.href = this.value();
								downloadButton.innerHTML = "<span class='k-icon k-i-download'></span>";
								downloadButton.style.cssText += "float: right; margin-right: 7px; color: #FFF;";
								toolbar.append(downloadButton);

								$(downloadButton).click((e) =>
								{
									if (toolbarItem.click != null)
									{
										let event = new ImageToolbarClickEvent();
										event.sender = this;
										toolbarItem.click(event);
									}
								});
							}
							break;
						case ImageToolbarTypeEnum.Delete:
							{
								$("#deleteToolbarImage_" + element.id).remove();
								let deleteButton = document.createElement("a");
								deleteButton.id = "deleteToolbarImage_" + element.id;
								deleteButton.innerHTML = "<span class='k-icon k-i-delete'></span>";
								deleteButton.style.cssText += "float: right; margin-right: 7px; color: #FFF; cursor: pointer;";
								toolbar.append(deleteButton);

								$(deleteButton).click((e) =>
								{
									this.clear();
									$("#toolbarImage_" + element.id).hide();

									if (toolbarItem.click != null)
									{
										let event = new ImageToolbarClickEvent();
										event.sender = this;
										toolbarItem.click(event);
									}
								});
							}
							break;
						case ImageToolbarTypeEnum.Custom:
							{
								$("#customToolbarImage_" + element.id + "_" + toolbarItem.value).remove();
								let customButton = document.createElement("a");
								customButton.id = "customToolbarImage_" + element.id + "_" + toolbarItem.value;
								customButton.innerHTML = DOMPurify.sanitize("<span class='k-icon k-i-" + toolbarItem.icon + "'></span>");
								customButton.style.cssText += "float: right; margin-right: 7px; color: #FFF; cursor: pointer;";
								toolbar.append(customButton);

								$(customButton).click((e) =>
								{
									if (toolbarItem.click != null)
									{
										let event = new ImageToolbarClickEvent();
										event.sender = this;
										toolbarItem.click(event);
									}
								});
							}
							break;
					}
				}
			}
			//#endregion

			//#region Overlay description
			if (options.overlayDescription !== false)
			{
				if (options.overlayDescription == true) options.overlayDescription = "";

				$("#overlayDescription_" + element.id).remove();
				let overlayDescription = document.createElement("div");
				overlayDescription.id = "overlayDescription_" + element.id;
				overlayDescription.innerHTML = DOMPurify.sanitize(options.overlayDescription);
				overlayDescription.style.cssText += "z-index: 1; width: Calc(100% - 20px); background-color: #000; color: #FFF; opacity: 0.7; position: absolute; bottom: 10px; display: none;";
				$(element.parentElement!).prepend(overlayDescription);
			}
			//#endregion
		}

		clear()
		{
			this.element.removeAttr("src");
		}

		value(pathOrBytes?: string, type?: ImageSourceTypeEnum, fileName?: string, mimeType?: string)
		{
			if (pathOrBytes != null && pathOrBytes != "")
			{
				mimeType = (mimeType == null) ? "image/png" : mimeType;
				fileName = (fileName == null) ? "download" : fileName;
				pathOrBytes = pathOrBytes.replace(/^data:image\/[^;]+;base64,/, '');

				let prePath = ((this.options as KendoWidgets.ImageOptions).base64) ? "data:" + mimeType + ";base64," : "";
				if (type != null && type == ImageSourceTypeEnum.Base64Bytes)
					prePath = "data:" + mimeType + ";base64,";

				this.element.attr("src", prePath + pathOrBytes);

				//#region Download
				if (type == ImageSourceTypeEnum.Base64Bytes)
					pathOrBytes = pathOrBytes.replace(/^data:image\/[^;]+/, 'data:application/octet-stream');

				$("#downloadToolbarImage_" + this.element[0].id).attr("href", prePath + pathOrBytes);
				$("#downloadToolbarImage_" + this.element[0].id).attr("download", fileName);
				//#endregion 
			}

			return this.element.attr("src");
		}

		overlayDescription(description: string)
		{
			if (this.options.overlayDescription !== false)
				$("#overlayDescription_" + this.element.attr("id")).html(DOMPurify.sanitize(description));
		}

		window()
		{
			return $("#imageWindow_" + this.element[0].id).data("kendoWindow") as KendoWidgets.Window;
		}

		windowTitle(title?: string)
		{
			if (title != null)
				this.window().title(title);

			return this.window().title();
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
	}

	Image.fn = Image.prototype;
	Image.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
	Image.fn.options.name = "Image";
	kendo.ui.plugin(Image);

	export enum ImagePositionTypeEnum
	{
		Center,
		Fit,
		Fill,
		Stretch,
		Original
	}

	export enum ImageSourceTypeEnum
	{
		Path,
		Base64Bytes
	}

	export class ImageClickEvent
	{
		sender: KendoWidgets.Image;
	}

	export class ImageToolbarItem
	{
		type: ImageToolbarTypeEnum;
		icon?: string;
		value?: string;
		click?(e: ImageToolbarClickEvent): void;
	}

	export enum ImageToolbarTypeEnum
	{
		Download,
		Delete,
		Custom
	}

	class ImageToolbarClickEvent
	{
		sender: KendoWidgets.Image;
	}
}

interface JQuery
{
	kendoImage(options?: KendoWidgets.ImageOptions): JQuery;
	data(key: "kendoImage"): KendoWidgets.Image;
}